import { message } from 'antd'
import React, { useEffect } from 'react'

import { useDispatch, useSelector } from 'react-redux'
import { tablesUpdate } from 'store/modules/tables/actions'
import { RootState } from 'store/modules/rootReducer'
import { _antdStatus } from 'store/modules/import/importActionTypes'
import LoadingBar from 'components/LoadingBar/LoadingBar'
import { pricingRepository } from 'egi/repositories/ImportRepository'
import { IImportFile, IImportTypes } from '../../importInterfaces'
import { ImportActions } from 'store/modules/import/importActions'

export interface ILoadingImportBarProps {
  type: IImportTypes
  importFile: IImportFile | undefined
  onImport: (data: IImportFile | undefined) => void
}

function LoadingImportBar ({ type, importFile, onImport }: ILoadingImportBarProps) {
  const dispatch = useDispatch()

  const loadingState = useSelector((state: RootState) => state.loadingReducer)

  const setPercentage = (payload: number) => dispatch(ImportActions.setPercentage(payload))
  const setStatus = (payload: string | null) => dispatch(ImportActions.setStatus(payload))
  const setAntdStatus = (payload: _antdStatus) => dispatch(ImportActions.setAntdStatus(payload))

  const getFileStatus = async () => {
    try {
      if (!importFile?._id) throw new Error('Não foram encontradas importações')
      const isNotaryFees = type === IImportTypes.notaryFees
      const response = isNotaryFees ? await pricingRepository.getNotaryFeesFileStatus(importFile?._id) : await pricingRepository.getOutstandingBalanceFileStatus(importFile?._id)
      setStatus(isNotaryFees ? response.data.data.notaryFee.status : response.data.data.outstandingBalance.status)
    } catch (err: any) {
      setStatus('failed')
      message.error(err.message)
    }
  }

  const resetLoading = () => {
    setTimeout(() => {
      dispatch(ImportActions.reset())
      onImport(undefined)
      dispatch(tablesUpdate())
    }, 1000)
  }

  useEffect(() => {
    if (importFile) {
      const interval = setInterval(() => {
        getFileStatus()
      }, 2000)

      return () => clearInterval(interval)
    }
  }, [importFile])

  useEffect(() => {
    if (loadingState?.status === 'succeed') {
      setPercentage(100)
      setAntdStatus('success')
      resetLoading()
    } else if (loadingState?.status === 'failed') {
      setPercentage(100)
      setAntdStatus('exception')
      resetLoading()
    }
  }, [loadingState?.status])

  useEffect(() => {
    if (
      loadingState?.status !== 'failed' &&
      loadingState?.status !== 'succeed' &&
      loadingState?.percentage < 100 &&
      importFile
    ) {
      const timeout = setTimeout(() => {
        setPercentage(Math.min(loadingState?.percentage + 10, 100))
      }, 2000)

      return () => clearTimeout(timeout)
    }
  }, [loadingState?.status, loadingState?.percentage])

  return importFile ? (
    <div className="loading-import-bar__card">
      <h3>Importando arquivo…</h3>
      <LoadingBar percent={loadingState?.percentage} status={loadingState?.antdStatus} />
    </div>
  ) : null
}

export default LoadingImportBar
